import { IUser } from '../../interfaces/models/user'

/** Survey/sync onboarding applies to accounts created on or after this date (UTC). Set in .env: REACT_APP_ONBOARDING_SURVEY_REQUIRED_AFTER */
const ONBOARDING_SURVEY_REQUIRED_AFTER_MS = (() => {
    const raw = process.env.REACT_APP_ONBOARDING_SURVEY_REQUIRED_AFTER ?? '2026-06-01'
    const iso = raw.includes('T') ? raw : `${raw}T00:00:00.000Z`
    const ms = Date.parse(iso)
    return Number.isFinite(ms) ? ms : Date.parse('2026-06-01T00:00:00.000Z')
})()

const OBJECT_ID_RE = /^[a-f0-9]{24}$/i

function getCreationMsFromMongoObjectId(id?: string): number | null {
    if (!id || !OBJECT_ID_RE.test(id)) return null
    const ms = parseInt(id.slice(0, 8), 16) * 1000
    return Number.isFinite(ms) ? ms : null
}

function getUserCreatedAtMs(user?: IUser | null): number | null {
    if (!user) return null
    const raw = user.createdAt ?? (user as { created_at?: string | number }).created_at
    if (raw != null && raw !== '') {
        const ms = typeof raw === 'number' ? raw : Date.parse(String(raw))
        if (Number.isFinite(ms)) return ms
    }
    return getCreationMsFromMongoObjectId(user._id)
}

const isLegacyAccountBeforeSurveyOnboarding = (user?: IUser | null): boolean => {
    const createdMs = getUserCreatedAtMs(user)
    if (createdMs === null) return false
    return createdMs < ONBOARDING_SURVEY_REQUIRED_AFTER_MS
}

/** Survey done, or account predates survey onboarding (no sync/survey steps on login). */
export const isOnboardingSurveyCompleted = (user?: IUser | null): boolean =>
    Boolean(user?.preferences?.hearAboutLeadDelta) || isLegacyAccountBeforeSurveyOnboarding(user)

/** Finished onboarding in app — use ConnectLinkedInProfileModal instead of legacy SyncConnectionsModal. */
export const shouldSuppressLegacySyncConnectionsModal = (
    user?: IUser | null,
    onboardingStep?: number
): boolean => isOnboardingSurveyCompleted(user) && (onboardingStep ?? -2) < 0
